import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

export default class FollowButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveringOnFollowing: false,
    };
  }

  showUnfollowText = () => {
    this.setState({ hoveringOnFollowing: true });
  }

  hideUnfollowText = () => {
    this.setState({ hoveringOnFollowing: false });
  }

  render() {
    const { userId, doIFollow, onClick } = this.props;

    // TODO: This component needs refactoring as we shouldn't have logic like this inside this component 
    let followStatus;
    if (doIFollow && doIFollow.length > 0) {
      doIFollow.forEach((object) => {
        if (object.user_id === userId.toString()) {
          followStatus = object.doIFollow;
        }
      });
    }

    let followingBtnText;
    let followBtnClasses;
    if (this.state.hoveringOnFollowing) {
      followingBtnText = `Unfollow`;
      followBtnClasses = `btn--destructive`;
    } else {
      followingBtnText = `Following`;
    }

    switch (followStatus) {
      case true:
        return (
          <Button
            onMouseEnter={this.showUnfollowText}
            onMouseLeave={this.hideUnfollowText}
            onClick={() => onClick(`unfollow`)}
            size="s"
            classes={followBtnClasses}
          >
            {followingBtnText}
          </Button>
        );

      case false:
        return (
          <Button
            onClick={() => onClick(`follow`)}
            classes="btn--secondary"
            size="s"
            spinColor="green"
          >
            Follow
          </Button>
        );

      default:
        return null;
    }
  }
}

FollowButton.propTypes = {
  userId: PropTypes.number.isRequired,
  doIFollow: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/FollowButton.js